(() => {
  const openMotif = () => {
    const id = window.location.hash.slice(1);
    if (!/^kad-motiv-\d{2}$/.test(id)) return;
    const panel = document.getElementById(id);
    if (!(panel instanceof HTMLDetailsElement)) return;
    panel.open = true;
    panel.scrollIntoView({block: 'start'});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openMotif, {once: true});
  else openMotif();
  window.addEventListener('hashchange', openMotif);
})();

(() => {
  let bannerLoad;
  const preferences = async () => {
    if (!window.privacyBanner?.showPreferences) {
      if (!bannerLoad) bannerLoad = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timer = window.setTimeout(() => reject(new Error('Privacy banner unavailable')), 8000);
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
        script.onload = () => { window.clearTimeout(timer); resolve(); };
        script.onerror = () => { window.clearTimeout(timer); reject(new Error('Privacy banner unavailable')); };
        document.head.appendChild(script);
      });
      await bannerLoad;
    }
    await window.privacyBanner.showPreferences();
  };
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-kad-privacy]');
    if (!link) return;
    event.preventDefault();
    if (link.hasAttribute('aria-busy')) return;
    link.setAttribute('aria-busy', 'true');
    try { await preferences(); }
    catch { window.location.assign(link.href); }
    finally { link.removeAttribute('aria-busy'); }
  });
})();


/* KAD iframe title accessibility: third-party video and payment frames may be created after page load. */
(() => {
  const titleFor = frame => {
    if (frame.hasAttribute('title') && frame.getAttribute('title')?.trim()) return;
    let src = '';
    try { src = new URL(frame.getAttribute('src') || '', location.href).hostname; } catch {}
    let title = 'Eingebetteter Inhalt';
    if (/youtube|youtu\.be/.test(src)) title = 'YouTube-Video';
    else if (/vimeo/.test(src)) title = 'Vimeo-Video';
    else if (/recaptcha|google\.com/.test(src)) title = 'Sicherheitsprüfung';
    else if (/shopify|paypal|klarna/.test(src)) title = 'Zahlungs- und Shopfunktion';
    frame.setAttribute('title', title);
  };
  const scanNode = node => {
    if (!(node instanceof Element)) return;
    if (node.matches('iframe')) titleFor(node);
    node.querySelectorAll('iframe').forEach(titleFor);
  };
  const init = () => {
    scanNode(document.body);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) scanNode(node);
      }
    });
    observer.observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
